import { mapGetters } from 'vuex'

export default {
    computed: {
        ...mapGetters({
            isDigitalClassRoomTraining: 'Courses/isDigitalClassRoomTraining',
            canUserSeeTest: 'VideoPlayer/canUserSeeTest',
            getCertificateForCourse: 'CompletedCourses/getCertificateForCourse',
            isMicroLearningCourse: 'MicroLearning/isMicroLearningCourse',
            canMicroLearningTestBeOpen: 'MicroLearning/canMicroLearningTestBeOpen'
        }),
        courseWithoutTestCompleted () {
            if (!this.course) {
                return false
            }
            return !this.course.isTestAvailable && this.canUserSeeTest
        },
        isMicroLearningCourse () {
            return this.course.elements.length > 1
        },
        isDigitalClassRoom () {
            return this.isDigitalClassRoomTraining(this.course)
        },
        courseCompleted () {
            return this.getCertificateForCourse(this.course.id)
        },
        isCourseTestAvailable () {
            return this.isMicroLearningCourse ? this.canMicroLearningTestBeOpen : this.canUserSeeTest
        }
    }
}
